const columnData = [
  {
    header: "سال زراعی",
    accessorKey: "crop_year_name",
    cell: ({ getValue }: { getValue: () => any }) => {
      const value = getValue();
      return value ? value.toLocaleString("fa-IR") : "0";
    },
  },
  {
    header: "نام کشاورز",
    accessorKey: "farmer_name",
    enableColumnFilter: false,
    cell: ({ getValue }: { getValue: () => any }) => {
      const value = getValue();
      return value ? value.toLocaleString("fa-IR") : "0";
    },
  },
  {
    header: () => <span className="flex">جمع بار تحویلی <span className="text-blue-600">(تن)</span></span>,
    accessorKey: "sum_delivered_load",
    enableColumnFilter: false,
    cell: ({ getValue }: { getValue: () => any }) => {
      const value = getValue();
      return value ? value.toLocaleString("fa-IR") : "0";
    },
  },
  {
    header: () => <span className="flex">وزن سهمیه تفاله <span className="text-blue-600">(کیلوگرم)</span></span>,
    accessorKey: "waste_quota_weight",
    enableColumnFilter: false,
    cell: ({ getValue }: { getValue: () => any }) => {
      const value = getValue();
      return value ? value.toLocaleString("fa-IR") : "0";
    },
  },
  {
    header: () => <span className="flex">مبلغ سهمیه تفاله <span className="text-blue-600">(تومان)</span></span>,
    accessorKey: "waste_quota_price",
    enableColumnFilter: false,
    cell: ({ getValue }: { getValue: () => any }) => {
      const value = getValue();
      return value ? value.toLocaleString("fa-IR") : "0";
    },
  },
  {
    header: () => <span>تفاله تحویلی</span>,
    accessorKey: "waste_delivered",
    enableColumnFilter: false,
    cell: ({ getValue }: { getValue: () => any }) => {
      const value = getValue();
      return value ? value.toLocaleString("fa-IR") : "0";
    },
  },
  {
    header: () => <span className="flex">مبلغ واریزی تفاله <span className="text-blue-600">(تومان)</span></span>,
    accessorKey: "waste_deposit_amount",
    enableColumnFilter: false,
    cell: ({ getValue }: { getValue: () => any }) => {
      const value = getValue();
      return value ? value.toLocaleString("fa-IR") : "0";
    },
  },
];

export default columnData;